import { motion } from "framer-motion";
import { Send, Users, ExternalLink } from "lucide-react";
import { SITE, IMAGES } from "@/data/site";

const MEMES = [
  { src: IMAGES.memeMoon, alt: "Greater Bull to the moon", span: "md:col-span-2 md:row-span-2" },
  { src: IMAGES.memeKing, alt: "Greater Bull king", span: "" },
  { src: IMAGES.memeChart, alt: "Greater Bull smashing chart", span: "" },
  { src: IMAGES.memeChad, alt: "Greater Bull chad", span: "md:col-span-2" },
];

// X (Twitter) glyph
const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Community = () => {
  return (
    <section
      id="community"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="community-section"
    >
      <div className="absolute inset-0 bg-surface/40 -z-0" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 text-sm font-body font-bold tracking-widest uppercase text-solana mb-4">
            <Users className="w-4 h-4" /> The Herd
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase text-white leading-[0.95]">
            Join The <span className="fire-gradient-text">Stampede</span>
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            The strongest herd in crypto. Memes, alpha, and pure degen energy 24/7.
          </p>
        </motion.div>

        {/* Social CTAs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          <a
            href={SITE.links.twitter}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="community-twitter"
            className="group glass rounded-lg p-8 flex items-center gap-5 hover:border-white/40 hover:bg-white/5 transition-colors duration-300"
          >
            <div className="w-14 h-14 rounded-md bg-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors duration-300">
              <XIcon className="w-7 h-7" />
            </div>
            <div className="flex-1">
              <p className="font-display text-2xl uppercase text-white">Twitter / X</p>
              <p className="font-body text-sm text-gray-400">Follow @thegreaterbull for alpha & memes</p>
            </div>
            <ExternalLink className="w-5 h-5 text-gray-500 group-hover:text-white transition-colors duration-300" />
          </a>

          <a
            href={SITE.links.telegram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="community-telegram"
            className="group glass rounded-lg p-8 flex items-center gap-5 hover:border-solana/60 hover:bg-solana/10 transition-colors duration-300"
          >
            <div className="w-14 h-14 rounded-md bg-solana/20 flex items-center justify-center group-hover:bg-solana transition-colors duration-300">
              <Send className="w-7 h-7 text-solana group-hover:text-white transition-colors duration-300" />
            </div>
            <div className="flex-1">
              <p className="font-display text-2xl uppercase text-white">Telegram</p>
              <p className="font-body text-sm text-gray-400">Join the chat and never miss a beat</p>
            </div>
            <ExternalLink className="w-5 h-5 text-gray-500 group-hover:text-solana transition-colors duration-300" />
          </a>
        </div>

        {/* Meme gallery */}
        <h3 className="font-display text-2xl md:text-3xl uppercase text-white text-center mb-8">
          Meme <span className="fire-gradient-text">Gallery</span>
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[200px] gap-4">
          {MEMES.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative rounded-lg overflow-hidden border border-white/10 group ${m.span}`}
              data-testid={`meme-${i}`}
            >
              <img
                src={m.src}
                alt={m.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
